import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isUndefined } from 'lodash/lang';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';

import styles from '../Upload.module.scss';

const FileItem = ({
  src,
  isImage,
  Icon,
  name,
  isUploaded,
  isPending,
  errors,
  handleRemoveFile,
}) => {
  const { t } = useTranslation();

  return (
    <div key={name} className={styles.file}>
      {isImage ? (
        <div
          className={styles.thumbnailContainer}
          style={{
            backgroundImage: `url(${src})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }}
        />
      ) : (
        <div className={styles.iconContainer}>
          <Icon className={styles.icon} />
        </div>
      )}

      <div className={styles.fileInfo}>
        {isUploaded && <div className={styles.success}>{t('upload.success')}</div>}
        {isPending && <div className={styles.pending}>{t('upload.pending')}</div>}
        {!isUndefined(errors) && errors[src] && (
          <div className={styles.error}>{t(errors[src])}</div>
        )}
        <div className={styles.infoBlock}>
          <div className={styles.filename}>{name}</div>
        </div>
      </div>
      {!isUploaded && !isPending && (
      <IconButton
        className={styles.remove}
        onClick={(event) => {
          handleRemoveFile(src);
          event.stopPropagation();
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      )}
    </div>
  );
};

FileItem.propTypes = {
  src: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isImage: PropTypes.bool.isRequired,
  isUploaded: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}),
  Icon: PropTypes.elementType.isRequired,
  handleRemoveFile: PropTypes.func.isRequired,
};

FileItem.defaultProps = {
  errors: {},
};

export default FileItem;
